var render = function render(){var _vm=this,_c=_vm._self._c;return _c('keep-alive',[_c(_vm.component,_vm._b({tag:"component",on:{"navigate-to-content-click":_vm.onNavigateToContent}},'component',_vm.getitemprops,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }